
import { FaEnvelope, FaMapMarker, FaPhone } from 'react-icons/fa'
import GoogleMapComponent from '../components/GoogleMapComponent'
import Header from '../components/Header'
import { sendEmail } from '../services/email.service'
import { useState } from 'react'

const ContactPage = () => {


    const [data, setData] = useState({
        to: ``,
        subject: ``,
        body: ``,
        phone: ``,
        name: ``,
    })



    const onSubmit = e => {
        // e.preventDefault()
        console.log(e)
        console.log(data)
        sendEmail({ ...data })
        data({
            to: ``,
            subject: ``,
            body: ``,
            phone: ``,
            name: ``,
        })
    }

    return (
        <>
            <Header type="contact"></Header>

            <section className="bg-gray-50">

                <div className='bg-white w-full'>

                    <section className=" lg:w-[80%] lg:m-auto md:w-[90%] md:m-auto sm:w-[100%] sm:m-auto  py-4 px-6 mb-4">

                        <h1 className="text-center  font-bold text-[30px] py-4">Get in touch with us</h1>

                        <p className="text-center py-4 px-2 lg:w-[60%] lg:m-auto md:w-[60%] md:m-auto sm:w-[100%] sm:m-0  text-[16px] font-medium">
                            This all means that giving is a much more important element of hapiness than receiving.
                            Being able to give makes us feel like we're making a big impact on someone's life
                            This all means that giving is a much more important element of hapiness than receiving.
                            Being able to give makes us feel like we're making a big impact on someone's life
                        </p>
                    </section>
                </div>



                <section className="lg:w-[80%]  lg:m-auto md:w-[90%] md:m-auto sm:w-[100%] sm:m-auto px-4 py-12 my-6  flex justify-center gap-5   flex-wrap">

                    <div className='px-2'>

                        <div
                            className='py-4 px-7 flex flex-row gap-4 align-middle items-center bg-white rounded-lg w-[365px] border sm:w-full mb-4'>
                            <div className='px-2'>
                                <FaPhone className='text-red-500' size={20} />
                            </div>
                            <div className='px-3'>
                                <h1 className='text-[18px] font-bold'>Phone number</h1>
                                <p>+ (509) 3873-3954
                                </p>
                            </div>
                        </div>


                        <div
                            className='py-4 px-7 flex flex-row gap-4 align-middle items-center bg-white rounded-lg w-[365px] border sm:w-full mb-4'>
                            <div className='px-2'>
                                <FaPhone className='text-red-500' size={20} />
                            </div>
                            <div className='px-3'>
                                <h1 className='text-[18px] font-bold'>Fax address</h1>
                                <p>+(509) 3110-6699</p>
                            </div>
                        </div>


                        <div
                            className='py-4 px-7 flex flex-row gap-4 align-middle items-center bg-white rounded-lg w-[365px] border sm:w-full mb-4'>
                            <div className='px-2'>
                                <FaMapMarker className='text-red-500' size={20} />
                            </div>
                            <div className='px-3'>
                                <h1 className='text-[18px] font-bold'>Location</h1>
                                <p>2, avenue N prolongée, rue muguet,
                                    Impasse Denis.</p>
                            </div>
                        </div>




                        <div
                            className='py-4 px-7 flex flex-row gap-4 align-middle items-center bg-white rounded-lg w-[365px] border sm:w-full mb-4'>
                            <div className='px-2'>
                                <FaEnvelope className='text-red-500' size={20} />
                            </div>
                            <div className='px-3'>
                                <h1 className='text-[18px] font-bold'>Email</h1>
                                <p>contactonfej@gmail.com</p>
                            </div>
                        </div>

                    </div>

                    <div className='border bg-white rounded-lg px-6 mx-3 py-6'>
                        <form className="px-2">
                            <div className="text-[25px] font-bold mb-5 text-[#ffa809]">
                                <p>Contactez notre equipe </p>
                            </div>
                            <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 mb-3">
                                <input
                                    className="bg-opacity-5 bg-white   p-2 text-black border-solid border-2 border-[#ffa809]"
                                    type="text"
                                    placeholder="Name"
                                    required
                                    onChange={(e) => {
                                        setData(d => {
                                            return { ...d, name: e.target.value }
                                        })
                                    }}
                                    value={data.name}
                                ></input>
                                <input
                                    className="bg-opacity-5 bg-white p-2   text-black border-solid border-2 border-[#ffa809]"
                                    type="text"
                                    placeholder="Email"
                                    required
                                    onChange={(e) => {
                                        setData(d => {
                                            return { ...d, to: e.target.value }
                                        })
                                    }}
                                    value={data.to}
                                ></input>
                            </div>
                            <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 mb-3">
                                <input
                                    className="bg-opacity-5 bg-white   text-black  p-2 border-solid border-2 border-[#ffa809]"
                                    type="text"
                                    placeholder="Phone"
                                    required
                                    onChange={(e) => {
                                        setData(d => {
                                            return { ...d, phone: e.target.value }
                                        })
                                    }}
                                    value={data.phone}
                                ></input>

                                <input
                                    className="bg-opacity-5 bg-white  text-black p-2 border-solid border-2 border-[#ffa809]"
                                    type="text"
                                    placeholder="subject"
                                    required
                                    onChange={(e) => {
                                        setData(d => {
                                            return { ...data, subject: e.target.value }
                                        })
                                    }}
                                    value={data.subject}
                                ></input>
                            </div>

                            <div className="grid lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1">
                                <textarea
                                    rows={4.5}
                                    className="bg-opacity-5  my-2  text-black bg-black p-2 border-solid border-2 border-[#ffa809]"
                                    maxLength={255}
                                    placeholder="Detail..."
                                    name='body'
                                    onChange={(e) => {
                                        setData(d => {
                                            return { ...data, body: e.target.value }
                                        })
                                    }}
                                    value={data.body}
                                ></textarea>
                            </div>
                            <div className="bg-[#ffa809] w-24  h-10 flex items-center justify-center mt-10 text-white">
                                <button onClick={onSubmit} type="button">Submit</button>
                            </div>
                        </form>
                    </div>


                </section>

                <section className='w-full bg-white py-4 mb-8'>
                    <div className='text-center lg:px-[10rem] md:px-[12rem] sm:px-[.8rem] py-6 mb-6'>
                        <h1 className='text-[30px] font-bold py-4'>Find us on google map</h1>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged
                        </p>
                    </div>
                    <GoogleMapComponent />
                </section>


            </section>
        </>
    )
}


export default ContactPage